import { Box } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'

interface Props {
  focused: boolean
  isEditable: boolean
  height?: number | string
  width?: number | string
  parentDeterminesSize?: boolean
  hideGrayBackground?: boolean
  children: React.ReactNode
  backgroundColor?: string
  backgroundImage?: string
  backgroundImageOpacity?: number
  onFocus: () => void
  onDoubleClick?: () => void
}
export const FocusWrapper = ({
  focused,
  isEditable,
  height,
  width,
  parentDeterminesSize,
  hideGrayBackground,
  backgroundColor,
  backgroundImage,
  backgroundImageOpacity = 1,
  children,

  onFocus,
  onDoubleClick,
}: Props) => {
  const theme = useMinimalsTheme()

  return (
    <Box
      className={isEditable ? 'drag-handle' : 'nodrag'}
      sx={{
        cursor: isEditable ? 'grab' : 'default',
        '&:active': { cursor: 'grabbing' },
        borderRadius: theme.customRadius.large,
        padding: theme.customSpacing.l,
        height: parentDeterminesSize ? '100%' : 'fit-content',
        width: parentDeterminesSize ? '100%' : 'fit-content',
        border: isEditable && focused ? `2px solid ${theme.palette.common.black}` : undefined,
      }}
      onClick={() => onFocus()}
      onDoubleClick={onDoubleClick}
    >
      <Box
        sx={{
          height: height,
          width: width,
          borderRadius: theme.customRadius.large,
          backgroundColor:
            hideGrayBackground || backgroundImage
              ? 'transparent'
              : (backgroundColor ?? theme.palette.grey[300]),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {backgroundImage && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              borderRadius: theme.customRadius.large,
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: backgroundImageOpacity,
            }}
          />
        )}
        {children}
      </Box>
    </Box>
  )
}
